<template>
  <div>
    <div
      v-for="extra in extras"
      :key="extra.id"
      class="uk-margin-top"
    >
      <component
        :label="getLabel(extra)"
        :is-editor="isEditor"
        :is="getTypeComponent(extra.type)"
        :other-params="getExtraParams(extra)"
        :value="getExtraValue(extra)"
        :extra-id="extra.id"
        @value-changed="setExtraValue"
      />
    </div>
  </div>
</template>

<script>
import ExtrasInput from './ExtrasInput'
import ExtrasYesNo from './ExtrasYesNo'
import ExtrasCheckboxes from './ExtrasCheckboxes'
import ExtrasSelect from './ExtrasSelect'
import ExtrasPersons from './ExtrasPersons'
import { mapState } from 'vuex'
import _ from 'lodash'

export default {
  components: {
    ExtrasInput,
    ExtrasYesNo,
    ExtrasCheckboxes,
    ExtrasSelect,
    ExtrasPersons
  },
  props: {
    isEditor: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState({
      extras: state => state.store.extras,
      inquiry: state => state.store.inquiry,
      countries: state => state.store.countries
    })
  },
  mounted () {
    this.$bus.$on('validate-data', async (page) => {
      if (page === 'Extras') {
        this.$emit('on-validated', page)
      }
    })
  },
  methods: {
    getTypeComponent(type) {
      switch (type) {
        case 4:
          return ExtrasYesNo
        case 5:
          return ExtrasPersons
        case 6:
          return ExtrasSelect
        case 7:
          return ExtrasCheckboxes
        // 8 ve 9 için default component veya özel işlemler eklenebilir
        default:
          return ExtrasInput
      }
    },
    getLabel(extra) {
      // API'den gelen genelde 'name' alanı var, label yoksa ona fallback yap
      const translation = this.$t('formExtra.' + extra.id)
      if (translation && translation !== ('formExtra.' + extra.id)) {
        return translation
      } else if (extra.label) {
        return extra.label
      } else if (extra.name) {
        return extra.name
      } else {
        return ''
      }
    },
    getExtraValue(extra) {
      if (!this.inquiry || !this.inquiry.extras) return null

      // type 5 özel obje içeriyor
      if (extra.type === 5) {
        return this.inquiry.extras['id-' + extra.id] || { adults: 0, childs: 0, value: '' }
      }
      // Diğer tipler için direkt değer
      return this.inquiry.extras['id-' + extra.id] || null
    },
    getTranslationKey(prefix, label) {
      return prefix + '.' + _.kebabCase(label)
    },
    translateItems(extra) {
      if (!extra.items) return []

      return extra.items.map(i => {
        const translated = this.$t('extra.' + extra.id + '_' + i.id)
        return {
          id: i.id,
          // Eğer çeviri yoksa orijinal ismi göster
          name: translated !== ('extra.' + extra.id + '_' + i.id) ? translated : i.name
        }
      })
    },
    getExtraParams(extra) {
      let params = {}
      switch (extra.type) {
        case 4: // YesNo
          params = {
            items: { 1: this.$t('static_translation.ja'), 2: this.$t('static_translation.nein') }
          }
          break
        case 5: // Persons
          params = {
            placeholder: this.$t('static_translation.alter-der-kinder')
          }
          break
        case 6: // Select
        case 7: // Checkboxes
          params = {
            items: this.translateItems(extra)
          }
          break
        case 8:
          params = {
            text: this.$t(this.getTranslationKey('formExtra', extra.label)),
            type: extra.type
          }
          break
        case 9:
          params = {
            text: this.$t(this.getTranslationKey('formExtra', extra.text))
          }
          break
        default:
          params = {}
      }
      return params
    },
    setExtraValue(payload) {
      // Payload yapısı: { extraId, value } gibi varsayılıyor
      this.$store.commit('updateInquiryExtra', payload)
    }
  }
}
</script>
